import React, { useState, useEffect } from "react";
import WeekSelector from "../weekSelector";
import { Button, Table, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AdminReports = () => {
  const { t } = useTranslation();

  const [selectedWeek, setSelectedWeek] = useState(null);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);


  const fetchReports = async () => {
    if (!selectedWeek) return;
    setLoading(true);

    try {
      console.log('🔍 AdminReports - запитуємо дані для тижня:', selectedWeek);
      const res = await fetch(`/api/reports-by-week?week_number=${selectedWeek}`);
      const data = await res.json();
      console.log('📊 AdminReports - отримані дані:', data);
      console.log('📊 AdminReports - кількість рапортів:', data.length);
      setReports(data);
    } catch (err) {
      console.error("❌ Помилка отримання рапортів:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('🎯 AdminReports - selectedWeek змінився:', selectedWeek);
    if (selectedWeek) fetchReports();
  }, [selectedWeek]);

  useEffect(() => {
    console.log('📋 AdminReports - reports змінилися:', reports);
  }, [reports]);

  const publishOne = async (id) => {
    await fetch(`/api/publish-report/${id}`, { method: "PUT" });
    fetchReports();
  };

  const unpublishOne = async (id) => {
    await fetch(`/api/unpublish-report/${id}`, { method: "PUT" });
    fetchReports();
  };

  const publishAll = async () => {
    if (!selectedWeek) return;
    await fetch(`/api/publish-reports-batch`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ week_number: selectedWeek })
    });
    fetchReports();
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">📋 {t("raports")} {t("for").toLowerCase()} {t("week").toLowerCase()}</h2>

      <WeekSelector selectedWeek={selectedWeek} setSelectedWeek={setSelectedWeek} />

      {loading && <div className="text-center my-4"><Spinner animation="border" /></div>}

      {!loading && reports.length > 0 && (
        <div className="mt-3">
          <div className="d-flex justify-content-end mb-2">
            <Button variant="success" onClick={publishAll}>📢 {t("save")} {t("all").toLowerCase()}</Button>
          </div>

          <Table bordered responsive hover className="text-center">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>{t("driver")}</th>
                <th>{t("status")}</th>
                <th>{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report, index) => (
                <tr key={report.id}>
                  <td>{index + 1}</td>
                  <td>{report.firstName} {report.lastName}</td>
                  <td>
                    <span className={`badge bg-${report.status === 'published' ? 'success' : 'secondary'}`}>{report.status}</span>
                  </td>
                  <td>
                    {report.status === 'draft' ? (
                      <Button size="sm" variant="warning" onClick={() => publishOne(report.id)}>✅ {t("save")}</Button>
                    ) : (
                      <Button size="sm" variant="secondary" onClick={() => unpublishOne(report.id)}>⬅️ {t("draft")}</Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default AdminReports;
